import runes from "runes";

export const leadInitials = lead => {
  if (lead.full_name) {
    const name = lead.full_name.split(' ');

    return runes.substr(name[0], 0, 1) + runes.substr(name[1] || '', 0, 1);
  }
  else {
    return (runes.substr(lead.first_name || '', 0, 1) + runes.substr(lead.last_name || '', 0, 1)) || '';
  }
}

export const leadFullName = lead => {
  return (lead.full_name || `${lead.first_name} ${lead.last_name}`)
}

export const statusColor = status => {
  return `#${status.color}`;
}

export const statusBG = (status, alpha = 0.1) => {
  const r = parseInt(status.color.substring(0, 2), 16);
  const g = parseInt(status.color.substring(2, 4), 16);
  const b = parseInt(status.color.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
